import { Badge } from '@material-ui/core';
import WatchLaterOutlinedIcon from '@material-ui/icons/WatchLaterOutlined';
import Alert from '@material-ui/lab/Alert';
import { isAfter, subDays } from 'date-fns';
import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

import { useStyle } from '../styles';

export default function Refund() {
  const classes = useStyle();
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);
  const refund = (notifications || []).find((n) => n.type === ENotificationType.REFUND);

  if (!refund?.quantity) return null;

  const refundExpiring = refund?.dueDates?.find((dueDates) => {
    return isAfter(new Date(), subDays(new Date(dueDates.dueDate), 4));
  });

  return (
    <div>
      <Link to='/producer/request-management'>
        <div className={classes.content} id='refund-notification-link'>
          <div className={classes.type}>
            <h4>Reembolsos pendentes</h4>
            <Badge badgeContent={refund?.quantity || 0} color='error' classes={{ badge: classes.badgePosition }} showZero />
          </div>
          {refundExpiring && (
            <Alert icon={<WatchLaterOutlinedIcon />} severity='error' className={classes.alert}>
              Seu prazo de resposta para alguns reembolsos está se esgotando.
            </Alert>
          )}
        </div>
      </Link>
    </div>
  );
}
